"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastProvider = ToastProvider;
exports.useToast = useToast;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _lodash = require("lodash");

var _Toast = _interopRequireDefault(require("../../components/elements/Toast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ToastContext = _react.default.createContext();

function ToastWrapper(props) {
  var onExited = props.onExited,
      isOpen = props.isOpen,
      rest = _objectWithoutProperties(props, ["onExited", "isOpen"]);

  var _useState = (0, _react.useState)(isOpen === undefined ? true : isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      showToast = _useState2[0],
      setShowToast = _useState2[1];

  return _react.default.createElement(_Toast.default, _extends({
    onClose: function onClose() {
      setShowToast(false);
    },
    onExited: onExited,
    isOpen: showToast
  }, rest));
}

function ToastContainer(props) {
  var toasts = props.toasts,
      setToasts = props.setToasts;
  return (0, _reactDom.createPortal)(_react.default.createElement("div", {
    className: "overflow-hidden fixed bottom-0 right-0 left-0 lg:left-auto pointer-events-none"
  }, (0, _lodash.map)(toasts, function (toast) {
    return _react.default.createElement(ToastWrapper, _extends({
      key: toast.id
    }, toast, {
      onExited: function onExited() {
        return setToasts((0, _lodash.filter)(toasts, function (t) {
          return t.id !== toast.id;
        }));
      }
    }));
  })), document.body);
}

function ToastProvider(_ref) {
  var children = _ref.children;

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      toasts = _useState4[0],
      setToasts = _useState4[1];

  var addToastToQueue = (0, _react.useCallback)(function (_ref2) {
    var type = _ref2.type,
        header = _ref2.header,
        body = _ref2.body,
        actions = _ref2.actions,
        _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? '' : _ref2$className,
        _ref2$containerClassN = _ref2.containerClassName,
        containerClassName = _ref2$containerClassN === void 0 ? '' : _ref2$containerClassN;
    var id = (0, _lodash.uniqueId)();
    var newToast = {
      type: type,
      header: header,
      body: body,
      actions: actions,
      id: id,
      className: className,
      containerClassName: containerClassName
    };
    setToasts(function (oldToasts) {
      return [].concat(_toConsumableArray(oldToasts), [newToast]);
    });
  }, [setToasts]);
  return _react.default.createElement(ToastContext.Provider, {
    value: {
      addToastToQueue: addToastToQueue // expects header, body, actions (optional), type (optional - default is info), className (optional - default is '')

    }
  }, children, !(0, _lodash.isEmpty)(toasts) && _react.default.createElement(ToastContainer, {
    toasts: toasts,
    setToasts: setToasts
  }));
}

function useToast() {
  return (0, _react.useContext)(ToastContext);
}